import { OutlineEffect } from 'three-stdlib'
import type { WebGLRenderer, Scene, Camera } from 'three'

const OUTLINE_PARAMS = {
  defaultThickness: 0.0025,
  defaultColor: [0, 0, 0] as [number, number, number],
  defaultAlpha: 1,
  defaultKeepAlive: false,
}

export const THREE_OUTLINE_EFFECT_RENDER_PRIORITY = 100

interface ThreeOutlineEffectArgs {
  /** The instance of the renderer */
  gl: WebGLRenderer
}

export class ThreeOutlineEffect {
  outlineEffect: OutlineEffect
  renderPriority: number
  renderer: WebGLRenderer

  constructor({ gl }: ThreeOutlineEffectArgs) {
    this.renderPriority = THREE_OUTLINE_EFFECT_RENDER_PRIORITY
    this.outlineEffect = new OutlineEffect(gl, OUTLINE_PARAMS)
    this.renderer = gl
  }

  start({
    width,
    height,
    invalidate,
  }: {
    width: number
    height: number
    invalidate: (frames?: number) => void
  }) {
    this.outlineEffect.setPixelRatio(this.renderer.getPixelRatio())
    this.outlineEffect.setSize(width, height, false)
    invalidate()
  }

  render(scene: Scene, camera: Camera) {
    this.outlineEffect.render(scene, camera)
  }
}
